import MainParticipantInfo from '../MainParticipantInfo/MainParticipantInfo';
import ParticipantTracks from '../ParticipantTracks/ParticipantTracks';
import React from 'react';
import useMainParticipant from '../../hooks/useMainParticipant/useMainParticipant';
import useSelectedParticipant from '../VideoProvider/useSelectedParticipant/useSelectedParticipant';
import useScreenShareParticipant from '../../hooks/useScreenShareParticipant/useScreenShareParticipant';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { sameAgoraParticipant } from '../../utils/sameAgoraParticipant';

export default function MainParticipant() {
  const mainParticipant = useMainParticipant();
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const [selectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();

  if (!mainParticipant || !localParticipant) return null;

  const isMainLocal = sameAgoraParticipant(mainParticipant, localParticipant);
  const isMainScreenSharer = screenShareParticipant ? sameAgoraParticipant(mainParticipant, screenShareParticipant) : false;

  const videoPriority =
    (sameAgoraParticipant(mainParticipant, selectedParticipant) ||
      sameAgoraParticipant(mainParticipant, screenShareParticipant)) &&
    !sameAgoraParticipant(mainParticipant, localParticipant)
      ? 'high'
      : null;

  return (
    <MainParticipantInfo participant={mainParticipant}>
      <ParticipantTracks
        participant={mainParticipant}
        videoOnly
        // In speaker view, always allow showing the screen track when the main tile is the screen-sharer
        // (including when you're the one sharing).
        enableScreenShare={isMainScreenSharer || !isMainLocal}
        videoPriority={videoPriority}
        isLocalParticipant={isMainLocal}
      />
    </MainParticipantInfo>
  );
}
